export default {
  presenter: 'jilek',
  title: 'Nebojte se příkazové řádky',
  subtitle: 'začátečníci',
  text: `
Příkazový řádek k Linuxu neodmyslitelně patří. A právě strach z práce v něm může být důvodem,
proč se někteří Linuxu obloukem vyhnou. Vyzkoušíme si, že to vlastně není nic složitého -
ukážeme si, jak funguje interpret příkazů Bash a naučíme se používat několik příkazů, které
"linuxákům" dennodenně usnadňují život.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/jilek-cmd.js